// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { fetchCardUniverses } from "../../api/cardOpening.jsx";
import { fetchCardPreview } from "../../api/cardOpening.jsx";
import { preloadUniverseImage } from "./assets.jsx";
import { preloadUniverseArtwork } from "./assets.jsx";
export async function loadStartupCards(u, o) {
  const {
      universe: m,
      universes: r
    } = await fetchCardUniverses(u),
    {
      cards: g
    } = await fetchCardPreview(u, m),
    j = g.filter(B => B.rarity.toLowerCase() !== "absolute").slice(0, 3);
  return await Promise.all(j.map(B => preloadUniverseImage(`/${B.thumbnailPath.replace(/^\/+/, "")}`))), o("banners"), await preloadUniverseArtwork(m, r), {
    universe: m,
    universes: r,
    cards: j
  };
}
